__turbopack_context__.v({
  "calendar": "calendar-module__c6G3_a__calendar",
  "caption": "calendar-module__c6G3_a__caption",
  "captionLabel": "calendar-module__c6G3_a__captionLabel",
  "card": "calendar-module__c6G3_a__card",
  "cell": "calendar-module__c6G3_a__cell",
  "clear": "calendar-module__c6G3_a__clear",
  "clearChoice": "calendar-module__c6G3_a__clearChoice",
  "clearLabel": "calendar-module__c6G3_a__clearLabel",
  "day": "calendar-module__c6G3_a__day",
  "disabled": "calendar-module__c6G3_a__disabled",
  "dropdown": "calendar-module__c6G3_a__dropdown",
  "dropdownRoot": "calendar-module__c6G3_a__dropdownRoot",
  "dropdowns": "calendar-module__c6G3_a__dropdowns",
  "grabber": "calendar-module__c6G3_a__grabber",
  "grid": "calendar-module__c6G3_a__grid",
  "hidden": "calendar-module__c6G3_a__hidden",
  "month": "calendar-module__c6G3_a__month",
  "months": "calendar-module__c6G3_a__months",
  "nav": "calendar-module__c6G3_a__nav",
  "navButton": "calendar-module__c6G3_a__navButton",
  "outside": "calendar-module__c6G3_a__outside",
  "popover": "calendar-module__c6G3_a__popover",
  "root": "calendar-module__c6G3_a__root",
  "selected": "calendar-module__c6G3_a__selected",
  "sheet": "calendar-module__c6G3_a__sheet",
  "sheetBody": "calendar-module__c6G3_a__sheetBody",
  "sheetClearLabel": "calendar-module__c6G3_a__sheetClearLabel",
  "today": "calendar-module__c6G3_a__today",
  "week": "calendar-module__c6G3_a__week",
  "weekday": "calendar-module__c6G3_a__weekday",
  "weekdays": "calendar-module__c6G3_a__weekdays",
});
